import { Component } from '@angular/core';
import { Notification, NotificationType } from '../../models/common.model';
import { NotificationService } from '../../service/notification/notification.service';

@Component({
    selector: 'app-notification',
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.scss'],
    standalone: false
})
export class NotificationComponent {

  constructor(public notificationService: NotificationService) {}

  handleOnClose(notification: Notification): void {
    this.notificationService.hideNotification(notification);
  }

  onMouseEnter(notification: Notification): void {
    this.notificationService.pauseTimer(notification);
  }

  onMouseLeave(notification: Notification): void {
    this.notificationService.resumeTimer(notification);
  }

  getDefaultTitle(type: NotificationType): string {
    switch (type) {
      case 'success':
        return 'Success';
      case 'warning':
        return 'Warning';
      case 'danger':
        return 'Error';
      case 'info':
        return 'Information';
      default:
        return 'Notification';
    }
  }

  trackById(index: number, alert: Notification) {
    return alert.count;
  }
}

